<template>
	<v-card v-if="condition">
		<slot></slot>
	</v-card>
	<div v-else>
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: "VCardWrapper",
		props: {
			condition: {
				type: Boolean,
				required: true,
			},
		},
	};
</script>
